export default __webpack_public_path__ + "static/media/surpressor-flat.06ffb8df.svg";